<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 md4>
      <v-form @submit.prevent="changePassword">
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ title }}</v-toolbar-title>

            <v-spacer />

            <v-toolbar-title>{{ applicationTitle }}</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <div>{{ text }}</div>

            <w-schema :model="$schema.password">
              <v-text-field
                prepend-icon="lock"
                label="Hasło"
                hint="Hasło musi składać się z minimum 8 znaków (w tym cyfry, znaku specjalnego oraz wielkiej litery)"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
              />
            </w-schema>

            <w-schema :model="$schema.repeat">
              <v-text-field
                prepend-icon="lock"
                label="Powtórz hasło"
                hint="Hasło musi składać się z minimum 8 znaków (w tym cyfry, znaku specjalnego oraz wielkiej litery)"
                :append-icon="showRepeat ? 'visibility' : 'visibility_off'"
                :type="showRepeat ? 'text' : 'password'"
                @click:append="showRepeat = !showRepeat"
              />
            </w-schema>
          </v-card-text>

          <v-divider />

          <v-card-actions>
            <v-spacer />

            <v-btn type="submit" color="primary">{{ confirmText }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/confirm.schema';
import { config } from '@/utils/config';

// @vuese
// Komponent resetu hasła
// @group Material
export default {
  mixins: [formMixin],
  schema,
  props: {
    // tytuł komponentu
    title: {
      type: String,
      required: true
    },
    // tekst do wyświetlenia w komponencie
    text: {
      type: String,
      required: false,
      default: ''
    },
    // tekst potwierdzającego przycisku
    confirmText: {
      type: String,
      required: false,
      default: 'Potwierdź'
    }
  },
  data() {
    return {
      applicationTitle: config.applicationTitle,
      model: {
        password: '',
        repeat: ''
      },
      showPassword: false,
      showRepeat: false
    };
  },
  methods: {
    // @vuese
    // Metoda waliduje formularz i zmienia hasło użytkownika
    changePassword() {
      if (!this.$schema.$validateAll().length) {
        // Emituje event do zmiany hasła
        // @arg Zwalidowane hasło
        this.$emit('change', this.model.password);
      }
    }
  }
};
</script>
